import _ from "lodash";
import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
	AGENT,
	DIRECTOR,
	FINANCE,
	INFORMATION_AGENT,
	MANAGER,
	PLAN_ADMINISTRATOR
} from "../../../../../../utils/Roles";
import * as types from "../../../../../../utils/data/dataActionTypes";
import * as dataActions from "../../../../../../utils/data/dataActions";
import { CLIENTS, USERS_V2 } from "../../../../../../utils/data/models";
import userHasAccess from "../../../../../../utils/userHasAccess";
import { RectangleSpinner } from "../../../../../common/spinners";
import OperationalContactFields from "./OperationalContactFields";
import { isSimpleFetchToast } from "../../../../../common/RouteValidators/ClientValidationHelper";
import { convertToPhoneNumberFormat } from "../../../../../common/Helpers/StringHelper";

class OperationalContactsPage extends React.Component {
	/**
		* Component that will pass down the form logic to the form.
		*/

	constructor(props, context) {
		super(props, context);
		this.state = {
			submitting: false,
			externalRole: false,
			initialValues: undefined,
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSubmit = _.debounce(this.handleSubmit.bind(this), 350); // Debounce func to avoid button spamming
		this.setInitialValues = this.setInitialValues.bind(this);
	}
	componentDidMount() {
		const externalRole = userHasAccess(
			[PLAN_ADMINISTRATOR, INFORMATION_AGENT],
			true
		);
		!externalRole && this.props.dataActions.getDataList(
			USERS_V2,
			0,
			0,
			"",
			["username:asc"],
			[USERS_V2.archiveFilter,`users.roleId=in=(${AGENT.roleId},${MANAGER.roleId},${DIRECTOR.roleId},${FINANCE.roleId})`]
		);
		this.setInitialValues(this.props.activeClient);
		this.setState({
			externalRole: externalRole
		});
	}
	setInitialValues(activeClient) {
		activeClient && (
			this.setState({
				initialValues: {
					clientId: activeClient.clientId,
					accountManagerId: activeClient.accountManagerId,
					accountManager: activeClient.accountManager,
					serviceRepresentativeId: activeClient.serviceRepresentativeId,
					serviceRepresentative: activeClient.serviceRepresentative,
					contactFirstName: activeClient.contactFirstName,
					contactLastName: activeClient.contactLastName,
					contactJobPosition: activeClient.contactJobPosition,
					contactPhoneNumber: activeClient.contactPhoneNumber,
					contactEmailAddress: activeClient.contactEmailAddress,
					contactLanguageCode: activeClient.contactLanguageCode,
					adminContactFirstName: activeClient.adminContactFirstName,
					adminContactLastName: activeClient.adminContactLastName,
					adminContactJobPosition: activeClient.adminContactJobPosition,
					adminContactPhoneNumber: activeClient.adminContactPhoneNumber,
					adminContactEmailAddress: activeClient.adminContactEmailAddress,
					adminContactLanguageCode: activeClient.adminContactLanguageCode,
					clientNumber: activeClient.clientNumber,
					businessAccountType: activeClient.businessAccountType,
					adminContactPhoneNumberExtension: activeClient.adminContactPhoneNumberExtension,
					contactPhoneNumberExtension: activeClient.contactPhoneNumberExtension
				}
			})
		);
	}

	handleSubmit(formValues) {
		this.setState({ submitting: true });
		formValues["isContactUpdate"] = true;
		const { activeClient, dataActions } = this.props;
		let clientToUpdate = activeClient;

		formValues["adminContactPhoneNumber"] = convertToPhoneNumberFormat(formValues["adminContactPhoneNumber"]);
		formValues["contactPhoneNumber"] = convertToPhoneNumberFormat(formValues["contactPhoneNumber"]);
		try {
			dataActions.updateDataItem(CLIENTS, formValues).then((data) => {
				const simpleFetchToast = isSimpleFetchToast(data);

				if(!simpleFetchToast) {
					if (data.type == types.UPDATE_DATA_ITEM_FAILURE) {
						toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
							type: toast.TYPE.ERROR,
							autoClose: false,
						});
						this.setState({ submitting: false });
					}
					else {
						toast(<FormattedMessage id="clientContacts.successOperationalToast" />, {
							type: toast.TYPE.SUCCESS,
							autoClose: 5000,
						});
						clientToUpdate = data.payload.data;
					}
				}
			});
			this.setState({ submitting: false });
		} catch (e) {
			toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
				type: toast.TYPE.ERROR,
				autoClose: false,
			});
			this.setState({ submitting: false });
		}
		this.setInitialValues(clientToUpdate);
	}


	render() {
		const { activeClient, userList, disabled } = this.props;
		const { initialValues, submitting, externalRole } = this.state;
		return (initialValues) ? (
			<div className="operational-contact-form">
				<OperationalContactFields
					submitting={submitting}
					initialValues={initialValues}
					client={activeClient}
					externalRole={externalRole}
					serviceRepresentative={activeClient.serviceRepresentative}
					accountManager={activeClient.accountManager}
					users={userList}
					disabled={disabled}
					onSubmit={this.handleSubmit}
				/>
			</div>
		) : (
			<RectangleSpinner />
		);
	}
}

OperationalContactsPage.propTypes = {
	activeClient: PropTypes.object,
	disabled: PropTypes.bool,
	dataActions: PropTypes.object,
	userList: PropTypes.array,
};

function mapDispatchToProps(dispatch) {
	return {
		dataActions: bindActionCreators(dataActions, dispatch),
	};
}

function mapStateToProps(state) {
	const userData = state.data.users ? state.data.users : [];
	let users = _.get(userData, "items") || [];
	const userList = users.map(({ userId, firstName, lastName }) => ({
		value: userId,
		text: `${firstName} ${lastName}`,
	}));
	return {
		userList: userList || [],
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(OperationalContactsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/operational-contacts/OperationalContactsPage.js